import { datadogRum } from '@datadog/browser-rum';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  datadogRum.init({
    applicationId: config.public.ddApplicationId,
    clientToken: config.public.ddApplicationToken,
    site: 'datadoghq.com',
    service: config.public.ddServiceName,
    version: config.public.ddVersion,
    env: config.public.ddEnv,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    excludedActivityUrls: [/https:\/\/.*\.mixpanel\.com/],
    allowedTracingUrls: [
      /https:\/\/.*\.acvauctions\.com\/.*/,
      (url) => url.includes('transport-load-board-bff'),
      'https://transport-load-board-bff.gateway.latest.acvauctions.com/api/transport-requests/overdue/count',
      'https://transport-load-board-bff.gateway.internal.acvauctions.com/api/transport-requests/overdue/count',
      'https://transport-load-board-bff.gateway.staging.acvauctions.com/api/transport-requests/overdue/count',
    ],
    beforeSend: (event) => {
      if (
        event.type === 'error' &&
        event.error.message.includes('Login required')
      ) {
        return false;
      }
    },
  });
});
